import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInAnonymously } from 'firebase/auth';

let firebaseServices;

function readFirebaseConfig() {
  return {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };
}

function hasValidFirebaseConfig(config) {
  const hasAllValues = Object.values(config).every(
    (value) => typeof value === 'string' && value.trim().length > 0
  );
  return hasAllValues && /^AIza[\w-]{35}$/.test(config.apiKey);
}

export function getFirebaseServices() {
  if (firebaseServices !== undefined) return firebaseServices;

  const config = readFirebaseConfig();
  if (!hasValidFirebaseConfig(config)) {
    firebaseServices = null;
    return firebaseServices;
  }

  const app = initializeApp(config);
  firebaseServices = {
    auth: getAuth(app),
    db: getFirestore(app),
  };

  return firebaseServices;
}

export async function ensureAuth(auth) {
  if (!auth.currentUser) {
    await signInAnonymously(auth);
  }
  return auth.currentUser;
}
